import { render, staticRenderFns } from "./fastvaluedeal-table.vue?vue&type=template&id=2ba7d8eb&scoped=true&"
import script from "./fastvaluedeal-table.vue?vue&type=script&lang=js&"
export * from "./fastvaluedeal-table.vue?vue&type=script&lang=js&"
import style0 from "./fastvaluedeal-table.vue?vue&type=style&index=0&id=2ba7d8eb&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ba7d8eb",
  null
  
)

export default component.exports